// import {
//     Drawer,
//     DrawerBody,
//     DrawerContent,
//     DrawerFooter,
//     DrawerHeader,
//     DrawerOverlay,
//     DrawerCloseButton,
//     FormLabel
// } from "@chakra-ui/react";
// import { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import ProgressBar from "../../../utils/progressBar/ProgressBar";
// import {addSolarBrand, updateSolarBrand} from '../../../redux/api/solarBrandApi/SolarbrandApi.js';
// import addSolarBrandAction from '../../../redux/reduxSlice/SolarBrandSlice.js';
// import { useDispatch } from 'react-redux';
// export function SolarBrandForm(props) {

//     const { dataToEdit, setIsUpdateMode, isUpdateMode, solarInverterId } = props;
//     console.log("dataToEdit", props)
//     const [showProgressBar, setShowProgressBar] = useState(false);
//     const closeDrawer = props.closeSolarBrand;
//     const initialFormData = {
//         solarBrandName: "",
//         solarBrandDescription: ""
//     }
//     const [formData, setFormData] = useState(initialFormData);
//     const dispatch = useDispatch();

//     // UpdateMode Use-effect
//     useEffect(() => {
//         if (isUpdateMode && dataToEdit) {
//             setFormData((prev) => ({
//                 ...prev, ...props.dataToEdit,
//             }))
//             console.log("formData", formData)   
//         }
//     }, [isUpdateMode, dataToEdit]);

//     const handleOnClose = () => {
//         closeDrawer()
//         setFormData(initialFormData);
//     }

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prevState => ({
//             ...prevState,
//             [name]: value
//         }));
//     }

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         console.log("submit", formData)
//         setShowProgressBar(true)
//         addSolarBrand({...formData, createdBy: localStorage.getItem("email")}).then((response) => {
//             // addSolarBrandAction(formData)
//             const ROWID = response.data.resp.ROWID;
//             console.log("ROWID", ROWID)
//             if(response.data.success === true){ 
//                 toast.success("Solar Inverter action successful")
//                 dispatch(addSolarBrandAction({ROWID, formData} ));
//             }else{
//                 toast.error("Solar Inverter action failed")
//             }
//         })
//         .catch((error) => {
//             console.log("Error is - ", error)
//             toast.error("Solar Inverter action failed")
//         })

//         setTimeout(() => {
//             setShowProgressBar(false);
//             toast.success("Solar Inverter action successful");
//             closeDrawer();
//             handleOnClose(); // Added handleOnClose call here
//         }, 1000);
//     }

//     const handleUpdate = (e) => {
//         e.preventDefault();
//         console.log("update", formData)
//         setShowProgressBar(true)
//         updateSolarBrand(formData.ROWID, formData).then((response) => {
//             console.log("response", response);
//             setShowProgressBar(false);
//             toast.success("Solar Brand successful");
//         })
//         .catch((error) => {
//             console.log("Error is - ", error);
//             setShowProgressBar(false);
//             toast.error("Solar Brand successful");
//         })
//         // Simulate API call delay
//         setTimeout(() => {
//             setShowProgressBar(false);
//             // toast.success("Solar Brand successful");
//             closeDrawer();
//             handleOnClose(); // Added handleOnClose call here
//         }, 1000);
//     }

//     return (
//         <>
//             <Drawer isOpen={props.isSolarBrand} size='xl' onClose={handleOnClose}>
//                 <DrawerOverlay />
//                 <DrawerContent>
//                     <DrawerCloseButton />
//                     <DrawerHeader>{isUpdateMode ? "Update Solar Panel Brand" : "Create Solar Panel Brand"}</DrawerHeader>
//                     <DrawerBody>
//                         {showProgressBar && <ProgressBar colorScheme='pink' />}
//                         <form onSubmit={isUpdateMode ? handleUpdate : handleSubmit}>
//                             <div className='card'>
//                                 <div className='card-body'>
//                                     <div className='row '>
//                                         <legend style={{ fontSize: 'Large' }} className='sub-headers'>Solar Panel Brand Information</legend>
//                                         <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
//                                             <div className='search-by-title'>
//                                                 <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Solar Panel Brand Name' name='solarBrandName' value={formData?.solarBrandName} onChange={handleChange} />
//                                             </div>
//                                             <FormLabel className="small-label ps-3">Solar Panel Brand Name<span style={{ color: 'red' }}>*</span></FormLabel>
//                                         </div>
//                                         <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
//                                             <div className='search-by-title'>
//                                                 <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Solar Panel Brand Description' name='solarBrandDescription' value={formData?.solarBrandDescription} onChange={handleChange} />
//                                             </div>
//                                             <FormLabel className="small-label ps-3">Solar Panel Brand Description</FormLabel>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </form>
//                     </DrawerBody>
//                     <center><DrawerFooter style={{ display: 'inline-block' }} >
//                         <div className='gap-3 d-flex'>
//                             <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
//                                 Cancel
//                             </button>
//                             <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handleUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
//                         </div>
//                     </DrawerFooter></center>
//                 </DrawerContent>
//             </Drawer>
//         </>
//     )
// }


import {
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerCloseButton,
    FormLabel
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import {addSolarBrand, updateSolarBrand} from '../../../redux/api/solarBrandApi/SolarbrandApi.js';
import { addSolarBrandAction, updateSolarBrandAction } from '../../../redux/reduxSlice/SolarBrandSlice.js';
import { useDispatch } from 'react-redux';

export function SolarBrandForm(props) {
    const { dataToEdit, setIsUpdateMode, isUpdateMode, solarInverterId } = props;
    console.log("dataToEdit", props);
    const [showProgressBar, setShowProgressBar] = useState(false);
    const closeDrawer = props.closeSolarBrand;
    const initialFormData = {
        solarBrandName: "",
        solarBrandDescription: ""
    };
    const [formData, setFormData] = useState(initialFormData);
    const dispatch = useDispatch();

    // UpdateMode Use-effect
    useEffect(() => {
        if (isUpdateMode && dataToEdit) {
            setFormData((prev) => ({
                ...prev, 
                ...dataToEdit,
            }));
            console.log("formData", formData);   
        }
    }, [isUpdateMode, dataToEdit]);

    const handleOnClose = () => {
        closeDrawer();
        setFormData(initialFormData);
        if (setIsUpdateMode) {
            setIsUpdateMode(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("submit", formData);
        setShowProgressBar(true);

        try {
            const response = await addSolarBrand({...formData, createdBy: localStorage.getItem("email")});
            const ROWID = response.data.resp.ROWID;
            console.log("ROWID", ROWID);
            
            if(response.data.success === true){ 
                // Dispatch the action to update Redux store
                dispatch(addSolarBrandAction({ROWID, formData}));
                toast.success("Solar Brand added successfully");
                closeDrawer();
                handleOnClose();
            } else {
                toast.error("Solar Brand action failed");
            }
        } catch (error) {
            console.log("Error is - ", error);
            toast.error("Solar Brand action failed");
        } finally {
            setShowProgressBar(false);
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        console.log("update", formData);
        setShowProgressBar(true);

        try {
            const response = await updateSolarBrand(formData.ROWID, formData);
            console.log("response", response);
            
            if(response.data.success === true) {
                // Dispatch update action to Redux store
                dispatch(updateSolarBrandAction(formData));
                toast.success("Solar Brand updated successfully");
                closeDrawer();
                handleOnClose();
            } else {
                toast.error("Solar Brand update failed");
            }
        } catch (error) {
            console.log("Error is - ", error);
            toast.error("Solar Brand update failed");
        } finally {
            setShowProgressBar(false);
        }
    };

    return (
        <>
            <Drawer isOpen={props.isSolarBrand} size='xl' onClose={handleOnClose}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>{isUpdateMode ? "Update Solar Panel Brand" : "Create Solar Panel Brand"}</DrawerHeader>
                    <DrawerBody>
                        {showProgressBar && <ProgressBar colorScheme='pink' />}
                        <form onSubmit={isUpdateMode ? handleUpdate : handleSubmit}>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row '>
                                        <legend style={{ fontSize: 'Large' }} className='sub-headers'>Solar Panel Brand Information</legend>
                                        <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className='search-by-title'>
                                                <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Solar Panel Brand Name' name='solarBrandName' value={formData?.solarBrandName} onChange={handleChange} />
                                            </div>
                                            <FormLabel className="small-label ps-3">Solar Panel Brand Name<span style={{ color: 'red' }}>*</span></FormLabel>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className='search-by-title'>
                                                <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Solar Panel Brand Description' name='solarBrandDescription' value={formData?.solarBrandDescription} onChange={handleChange} />
                                            </div>
                                            <FormLabel className="small-label ps-3">Solar Panel Brand Description</FormLabel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </DrawerBody>
                    <center><DrawerFooter style={{ display: 'inline-block' }} >
                        <div className='gap-3 d-flex'>
                            <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
                                Cancel
                            </button>
                            <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handleUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
                        </div>
                    </DrawerFooter></center>
                </DrawerContent>
            </Drawer>
        </>
    );
}